<template>
    <section>
        <!-- 查询栏 -->
        <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" >
			<el-form :inline="true" :model="filters" style="float: right;">
				<!-- <el-form-item>
					<el-input v-model="filters.shopname" placeholder="门店名称"></el-input>
				</el-form-item> -->
                <el-form-item v-if="JSON.parse(this.getuserstate()).TenancyId==0">
                <el-select  v-model="shopId" clearable filterable placeholder="选择或搜索门店" >
                 <el-option
               v-for="item in Shopoptions"
               :key="item.Id"
                  :label="item.Name"
               :value="item.Id">
                  </el-option>
                   </el-select>				
                   </el-form-item>
                <el-form-item>
                    <div class="block">
                   <el-date-picker
                        v-model="dateValue"
                         type="datetimerange"
                        :picker-options="pickerOptions"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        align="right">
                   </el-date-picker>
                    </div>
                   </el-form-item>
                   <!-- <el-form-item>
                <el-select v-model="stateValue" placeholder  placeholder="请选状态" style="width:192px">
                <el-option
                     v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
                </el-option>
                 </el-select>
                 </el-form-item> -->
				<el-form-item>
					<el-button type="primary" v-on:click="getShop" icon="el-icon-search">查询短信统计</el-button>
				</el-form-item>
		
			</el-form>
		</el-col>
        	<!--列表-->
		<el-table :data="shoplist" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" max-height="500"> 
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column prop="Date" label="日期" width="200" sortable :formatter="formatDate">
			</el-table-column>
			<el-table-column prop="Count" label="使用数量" min-width="180" sortable>
			</el-table-column>
			<!-- <el-table-column prop="UnitPrice" label="短信单价" width="120" sortable>
			</el-table-column> -->
			
	     	<!-- <el-table-column  prop="State" label="充值状态" width="120"sortable>
                  <template slot-scope="scope" >
                  <div slot="reference" class="name-wrapper">
                  <el-tag type="danger" size="medium" v-if="scope.row.State==0">已撤销</el-tag>
                  <el-tag type="success" size="medium" v-else>正常</el-tag>
                  </div>
                  </template>
			</el-table-column> -->
		
		</el-table>
        <!--工具条-->
		<el-col :span="24" class="toolbar">
			<!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
        	<el-tag>共有{{total}}条记录</el-tag>
			<!-- <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="10" :total="total" style="float:right;"> -->
			<!-- </el-pagination> -->
		</el-col>
    </section>
</template>
<script>
	import util from '../../common/js/util'
    import {MsgStatistics,getShopInfor } from '../../api/api';
    import {mapGetters} from 'vuex';

export default {
    data(){
        return{
             shopId:'',
            filters: {
					Name: ''
                },
              Shopoptions:[],
                 pickerOptions: {
              shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },

         dateValue: '',
        stateValue:'',

                 options: [{
                     value: '0',
                    label: '已撤销'
                    }, {
                      value: '1',
                     label: '正常'
                    } , {
                     value: ' ',
                     label: '不选择'
                    } ],

                shoplist: [],
				total: 0,
				page: 0,
                listLoading: false,
                sels: [],//列表选中列
        }
    },
    methods:{
        	formatDate: function (row, column) {
				return util.formatDate.format(new Date(row.Date), 'yyyy-MM-dd');
			},
        			...mapGetters(['getuserstate']),

     getShopList()
        {
            let para={}
            getShopInfor(para).then((res) => {                  
                    this.Shopoptions = res.data;       
				})
				 .catch(error=>{
                 alert('网络错误');
                });          				
        },
    
        formatState: function (row, column) {
			return row.State == 0? '已撤销' : '正常';
		},       
		closeing()
		{
            this. getShop();
		},
          	handleCurrentChange(val) {
                this.page = val;
				this.getShop();
			},
			CurrentChange(val)
			{
                this.logPage = val;
				this.rechargeLogData();
			},
			 getShop() {
                //  console.log(this.dateValue[1]);
                //  console.log(this.stateValue+1111);
				let Params = {
					// PageIndex: this.page,					
					// PageSize:10,
                    // Name:this.filters.shopname,
                    TenancyId:this.shopId,
                    StartDate:this.dateValue[0],
                    EndDate:this.dateValue[1],
                    // State:this.stateValue
                    
				};
				this.listLoading = true;
				MsgStatistics(Params).then((res) => {
                    // console.log(res);
                     let {Success,Msg}=res.data;
                    this.listLoading = false;
                  if(Success)
                  {
                      
                   this.total = res.data.ExtendData;                  
                    this.shoplist = res.data.Data;
                    // console.log( this.shoplist.Lenght);
                    // this.listLoading = false;
                  }
                  else
                  {
                                this.$message({
									message: Msg,
									type: 'error'
								});
                  }
                    
                    
				})
				 .catch(error=>{
                 alert('网络错误');
                });
            },				
			selsChange: function (sels) {
				this.sels = sels;
			},
    },
    mounted() {
            // this. getShop();
            this.getShopList();
		}
}
</script>




// WEBPACK FOOTER //
// ShopEventLog.vue?3ada6cc9